import {ActionType, Currency, extractCountry, Language} from "App/constants";
import {ThunkDispatch} from "redux-thunk";
import {AnyAction} from "redux";
import * as countries from 'i18n-iso-countries';
import {LocalizedCountryNames} from "i18n-iso-countries";

// register countries locale
Object.keys(Language).map(key => Language[key])
    .forEach(lang => countries.registerLocale(require("i18n-iso-countries/langs/" + lang + ".json")));

export function countriesByLanguage(language: Language): LocalizedCountryNames {
    return countries.getNames(language);
}

export function countryByLanguage(language: Language, countrycode: string): string {
    return countries.getNames(language)[countrycode];
}

export interface CurrencyProps {
    currency: Currency
}

export interface CountryCodeAction {
    type: ActionType.RETRIEVE_COUNTRY_CODE,
    countrycode: string;
}

export const countrycodeInitialState: string = 'CH';

export function countrycodeReducer(state: string = countrycodeInitialState, action: CountryCodeAction) {
    if (action && action.countrycode) {
        return action.countrycode;
    }
    return state;
}

function extractCountryCode(locale: string | undefined): string | undefined {
    const countryCode: string | undefined = locale && extractCountry(locale);
    return countryCode && countryCode !== '' ? countryCode : undefined;
}

function guessCountryCodeFromNavigator(): CountryCodeAction {
    return {
        type: ActionType.RETRIEVE_COUNTRY_CODE,
        countrycode: extractCountryCode(navigator.language) || extractCountryCode(navigator.languages.find(language => extractCountryCode(language) !== undefined)) || 'CH'
    };
}

export function guessCountryCode(): any {

    return async function (dispatch: ThunkDispatch<any, null, AnyAction>) {

        try {
            const response: Response = await fetch('https://api.db-ip.com/v2/free/self');
            if (response.status >= 200 && response.status < 300) {
                const data: object = await response.json();
                dispatch({type: ActionType.RETRIEVE_COUNTRY_CODE, countrycode: data['countryCode']});
            } else {
                dispatch(guessCountryCodeFromNavigator());
            }
        } catch (e) {
            dispatch(guessCountryCodeFromNavigator());
        }
    }
}



// WEBPACK FOOTER //
// ./src/country.ts